import { render, staticRenderFns } from "./statisticCard.vue?vue&type=template&id=e70177a8&scoped=true&"
import script from "./statisticCard.vue?vue&type=script&lang=js&"
export * from "./statisticCard.vue?vue&type=script&lang=js&"
import style0 from "./statisticCard.vue?vue&type=style&index=0&id=e70177a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70177a8",
  null
  
)

export default component.exports